//import logo from './logo.svg';
import './App.css';

//import App from './healthcare_marketing_website_single_file_react_tailwind';
// import Qwen_jsx_20250822_bbp7csdsl from './Qwen_jsx_20250822_bbp7csdsl';
// import Qwen_jsx_20250822_dqr4y9pe1 from './Qwen_jsx_20250822_dqr4y9pe1';
// import Qwen_jsx_20250825_z83kgy1ph from './Qwen_jsx_20250825_z83kgy1ph';
// import React_js_2_ภาษา_healthcare_rose_gold_landing_page from './react_js_2_ภาษา_healthcare_rose_gold_landing_page';

import ShortURL1 from './ShortURL1';
//import LoanCalculator from './LoanCalculator';
//import { BrowserRouter as Router, Routes, Route , Link } from "react-router-dom";

function App() {
   

     return (
  <div className="p-4">
        <ShortURL1 />
      </div>
  );
}

export default App;
